/* ==========================================================================
   CAPRIMAFFIA — cm-fluid.js · FLUIDEZ · 12 oct 2026
   --------------------------------------------------------------------------
   JS vanilla, sin librerias. Solo MARCA elementos con atributos `data-cmf-*`
   y el CSS hace el movimiento. Si este archivo no llegara a ejecutarse,
   la web queda exactamente como estaba: nada se oculta desde el HTML.

   Reglas que se respetan a proposito (lecciones del tema, ver memoria
   `home_top.md`):
   - Nada se mueve por fotograma a traves de variables CSS heredadas: el
     `transform` se escribe SIEMPRE en el propio elemento.
   - Ni una clase se pone o se quita en un contenedor grande para arrancar o
     parar una animacion.
   - `textContent` no se toca para animar: se escribe `nodo.data`, porque en
     este tema (Horizon) cambiar `textContent` dispara reglas `:has()` que
     recalculan el body entero.
   - En el unico bucle de rAF que hay, primero se LEE todo y despues se
     ESCRIBE todo, y la posicion en el documento esta cacheada: dentro del
     bucle no se lee ni un rectangulo.
   - LA PORTADA ESTA FUERA de casi todo: ahi vive el anillo 3D con su pin de
     ScrollTrigger y su propio sistema de movimiento (`ht-core.js`).
     Liquid solo le pone las clases `cmf` y `cmf-pop`.
   ========================================================================== */
(function () {
  'use strict';

  var B = document.body;
  if (!B || !B.classList.contains('cmf')) return;

  var has = function (c) { return B.classList.contains(c); };
  var mq = function (q) { return window.matchMedia ? window.matchMedia(q) : { matches: false }; };
  var REDUCED = mq('(prefers-reduced-motion: reduce)');
  var FINE = mq('(hover: hover) and (pointer: fine)');
  var EASE_D = 70; /* ms de desfase entre lineas / columnas */

  /* Zonas intocables. Dos familias:
     - la portada nueva y el anillo 3D, que ya tienen su propio movimiento;
     - lo de terceros (Judge.me, aviso de cookies, barra de vista previa,
       EcomSend) y todo lo que viva dentro de un dialogo o del cajon del
       carrito, que aparece y desaparece solo. */
  var FORBID = [
    '.ht-ap', '.ht-pas', '.ht-pl', '.ht-dec', '.ht-sa', '.ht-anillo',
    '.ha', '.ha__cam', '.ha__stage', '#htBand',
    '[class*="jdgm"]', '[class*="ecomsend"]', '[class*="EcomSend"]',
    '.shopify-pc__banner', '#PBarNextFrameWrapper',
    'dialog', '.cart-drawer', '#search-modal', '.quick-add-modal',
    '[class*="essential"]', '[class*="vestico"]'
  ].join(',');

  function banned(el) {
    try { return !!el.closest(FORBID); } catch (e) { return true; }
  }

  /* 🚨 `threshold: 0` SIEMPRE, y nunca 0.01.
     Un elemento que parte recortado (`clip-path: inset(0 0 100% 0)`) o
     encogido (`transform: scaleX(0)`) tiene AREA CERO, y Chrome calcula la
     interseccion sobre el rectangulo YA recortado: con cualquier umbral por
     encima de 0 la proporcion nunca llega y el observador NO DISPARA NUNCA.
     Medido en vivo el 12 oct: las 24 fichas de coleccion se quedaban
     invisibles para siempre. Con `threshold: 0` un area cero que cae dentro
     del marco cuenta como visible, que es justo lo que hace falta. */
  function io(cb, margin) {
    if (!('IntersectionObserver' in window)) return null;
    return new IntersectionObserver(function (entries, obs) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) { cb(entries[i].target); obs.unobserve(entries[i].target); }
      }
    }, { rootMargin: margin || '0px 0px -8% 0px', threshold: 0 });
  }

  /* ========================================================================
     1 · TRANSICION ENTRE PAGINAS
     El tema ya tiene las View Transitions encendidas. Aqui solo se hacen dos
     cosas: saltarse la transicion cuando el destino es la PORTADA (su anillo
     usa un pin de ScrollTrigger y un `view-transition-name` sobre `main`
     crearia bloque contenedor justo mientras GSAP esta midiendo), y
     saltarsela tambien cuando se va al carrito o a pagar, que son pasos en
     los que no se quiere ni un ms de espera.
     ===================================================================== */
  (function paginas() {
    if (!('onpageswap' in window)) return;
    window.addEventListener('pageswap', function (e) {
      if (!e.viewTransition) return;
      var entry = e.activation && e.activation.entry;
      if (!entry) return;
      var p;
      try { p = new URL(entry.url).pathname; } catch (err) { return; }
      if (p === '/' || /^\/(cart|checkout|challenge)/.test(p)) e.viewTransition.skipTransition();
    });
  }());

  /* ========================================================================
     2 · TITULARES QUE SE REVELAN POR LINEA
     Se parte el titular en las lineas REALES que el navegador ya ha
     compuesto: cada palabra se mide con su rectangulo y se agrupa por la
     altura a la que ha caido. Asi funciona con cualquier ancho, cualquier
     tamano de letra y cualquier idioma, sin repetir el texto.
     ===================================================================== */
  var SEL_TIT = 'main h1, main h2, main .cm-statement__text, main .pr-datos__t, main .influ__title';

  function partible(el) {
    if (!el || el.dataset.cmfRv) return false;
    if (banned(el)) return false;
    var t = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (!t || t.length > 150) return false;
    /* solo texto plano: en cuanto hay un enlace, un icono o una imagen
       dentro, partirlo se llevaria por delante su markup */
    for (var i = 0; i < el.children.length; i++) {
      if (el.children[i].tagName !== 'BR') return false;
    }
    var r = el.getBoundingClientRect();
    if (r.width < 40 || r.height < 8) return false;
    return true;
  }

  function partir(el) {
    var txt = (el.textContent || '').replace(/\s+/g, ' ').trim();
    var palabras = txt.split(' ');
    var alto0 = el.getBoundingClientRect().height;

    /* paso 1 — una caja por palabra, para poder medirlas */
    var frag = document.createDocumentFragment();
    var cajas = [];
    for (var i = 0; i < palabras.length; i++) {
      var s = document.createElement('span');
      s.style.display = 'inline-block';
      s.appendChild(document.createTextNode(palabras[i]));
      frag.appendChild(s);
      cajas.push(s);
      if (i < palabras.length - 1) frag.appendChild(document.createTextNode(' '));
    }
    var original = el.innerHTML;
    el.textContent = '';
    el.appendChild(frag);

    /* paso 2 — agrupar por la altura a la que ha caido cada palabra */
    var grupos = [], ultimo = null;
    for (var j = 0; j < cajas.length; j++) {
      var top = Math.round(cajas[j].getBoundingClientRect().top);
      if (ultimo === null || Math.abs(top - ultimo) > 2) { grupos.push([]); ultimo = top; }
      grupos[grupos.length - 1].push(cajas[j].textContent);
    }
    if (!grupos.length || grupos.length > 8) { el.innerHTML = original; return false; }

    /* paso 3 — una linea por grupo, con su desfase */
    el.textContent = '';
    for (var k = 0; k < grupos.length; k++) {
      var linea = document.createElement('span');
      linea.className = 'cmf-l';
      var dentro = document.createElement('span');
      dentro.appendChild(document.createTextNode(grupos[k].join(' ')));
      if (k) dentro.style.setProperty('--cmf-d', (k * EASE_D) + 'ms');
      linea.appendChild(dentro);
      el.appendChild(linea);
    }

    /* paso 4 — si partirlo le cambia el alto, se deshace: un titular que
       empuja la pagina al cargar vale menos que la animacion que gana */
    var alto1 = el.getBoundingClientRect().height;
    if (Math.abs(alto1 - alto0) > 2) { el.innerHTML = original; return false; }

    el.dataset.cmfRv = 'off';
    return true;
  }

  function titulares() {
    if (!has('cmf-tit')) return;
    var obs = io(function (el) {
      el.dataset.cmfRv = 'in';
      var ult = el.lastElementChild && el.lastElementChild.firstElementChild;
      if (ult) {
        ult.addEventListener('transitionend', function () { el.dataset.cmfRv = 'done'; }, { once: true });
      }
      setTimeout(function () { if (el.dataset.cmfRv !== 'done') el.dataset.cmfRv = 'done'; }, 2400);
    }, '0px 0px -6% 0px');

    var nodos = document.querySelectorAll(SEL_TIT);
    var hechos = 0;
    for (var i = 0; i < nodos.length && hechos < 40; i++) {
      if (!partible(nodos[i])) continue;
      if (!partir(nodos[i])) continue;
      hechos++;
      if (obs) obs.observe(nodos[i]); else nodos[i].dataset.cmfRv = 'done';
    }
    return hechos;
  }

  /* ========================================================================
     3 · ROTULOS MONO QUE SE DESCIFRAN (una vez)
     14 fotogramas de letras al azar que se van clavando de izquierda a
     derecha. Se escribe en `nodo.data`, nunca en `textContent` del elemento.
     ===================================================================== */
  var ALFA = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  var SEL_SC = 'main [class*="eyebrow"], main [class*="__kicker"], main [class*="__index"], main .cmf-sc';

  function descifrar(nodo, fin) {
    var pasos = 14, i = 0;
    var t = setInterval(function () {
      i++;
      var clavadas = Math.ceil(fin.length * (i / pasos));
      var s = fin.slice(0, clavadas);
      for (var k = clavadas; k < fin.length; k++) {
        s += /\s/.test(fin[k]) ? fin[k] : ALFA[(Math.random() * ALFA.length) | 0];
      }
      nodo.data = s;
      if (i >= pasos) { clearInterval(t); nodo.data = fin; }
    }, 30);
  }

  function rotulos() {
    if (!has('cmf-tit') || REDUCED.matches) return 0;
    var obs = io(function (el) {
      var nodo = el.firstChild;
      if (!nodo || nodo.nodeType !== 3) return;
      descifrar(nodo, nodo.data);
    });
    if (!obs) return 0;
    var nodos = document.querySelectorAll(SEL_SC), n = 0;
    for (var i = 0; i < nodos.length && n < 12; i++) {
      var el = nodos[i];
      if (banned(el) || el.children.length) continue;
      var t = (el.textContent || '').trim();
      if (!t || t.length > 28) continue;
      el.setAttribute('data-cmf-scramble', '');
      obs.observe(el);
      n++;
    }
    return n;
  }

  /* ========================================================================
     4 · HOVER DE RODILLO
     La copia que entra NO es texto del DOM: es `content: attr(data-t)` de un
     pseudo-elemento. Asi `textContent` del enlace sigue diciendo lo que
     decia (hay JS del tema que lo lee) y no hay texto duplicado para quien
     navegue con lector de pantalla.
     ===================================================================== */
  function rodillo() {
    if (!has('cmf-nav') || !FINE.matches || REDUCED.matches) return 0;
    var nodos = document.querySelectorAll('#header-group a, .shopify-section-group-footer-group a, footer a, .cm-servicebar a');
    var n = 0;
    for (var i = 0; i < nodos.length; i++) {
      var a = nodos[i];
      if (banned(a) || a.dataset.cmfRoll !== undefined) continue;
      if (a.children.length) continue;            /* iconos, logos, SVG: fuera */
      var t = (a.textContent || '').replace(/\s+/g, ' ').trim();
      if (!t || t.length > 30) continue;
      var r = a.getBoundingClientRect();
      if (r.height > 64) continue;                /* cajas grandes: no es un rotulo */
      var w = document.createElement('span');
      w.className = 'cmf-r';
      var inner = document.createElement('span');
      inner.className = 'cmf-r__i';
      inner.setAttribute('data-t', t);
      inner.appendChild(document.createTextNode(t));
      w.appendChild(inner);
      a.textContent = '';
      a.appendChild(w);
      a.setAttribute('data-cmf-roll', '');
      n++;
    }
    return n;
  }

  /* ========================================================================
     5 · LINEAS DE 1 PX QUE SE DIBUJAN
     Solo se tocan elementos que YA SON una linea: 3 px de alto o menos,
     mas de 40 px de ancho, y con color de fondo propio.
     ===================================================================== */
  function lineas() {
    if (!has('cmf-hov')) return 0;
    var obs = io(function (el) {
      el.setAttribute('data-cmf-line', 'in');
      setTimeout(function () { el.setAttribute('data-cmf-line', 'done'); }, 1200);
    });
    if (!obs) return 0;
    var nodos = document.querySelectorAll('main hr, main [class*="__rule"], main [class*="__sep"], main [class*="__line"]');
    var n = 0;
    for (var i = 0; i < nodos.length && n < 30; i++) {
      var el = nodos[i];
      if (banned(el)) continue;
      var r = el.getBoundingClientRect();
      if (r.height > 3 || r.width < 40) continue;
      el.setAttribute('data-cmf-line', '');
      obs.observe(el);
      n++;
    }
    return n;
  }

  /* ========================================================================
     6 · REJILLAS QUE ENTRAN POR CORTINA, ESCALONADAS
     El desfase va por COLUMNA, no por indice: las tarjetas de una misma fila
     entran una detras de otra de izquierda a derecha, y la fila de abajo
     vuelve a empezar. En movil no hay desfase (la fila es de una o dos
     tarjetas y escalonarlas solo se siente como retraso).
     Al terminar cada tarjeta se le quita el clip: un clip vivo recortaria el
     «anadir rapido» y dejaria una capa de composicion abierta por tarjeta.
     ===================================================================== */
  function rejillas() {
    if (!has('cmf-grid')) return 0;
    var movil = !FINE.matches || window.innerWidth < 750;
    var obs = io(function (el) {
      el.setAttribute('data-cmf-card', 'in');
      el.addEventListener('transitionend', function (ev) {
        if (ev.propertyName === 'clip-path') el.setAttribute('data-cmf-card', 'done');
      }, { once: true });
      setTimeout(function () { el.setAttribute('data-cmf-card', 'done'); }, 2600);
    }, '0px 0px 15% 0px');
    if (!obs) return 0;

    var pendientes = [];
    var n = 0;

    /* Marca las fichas de UNA rejilla que no esten marcadas ya. El desfase
       va por COLUMNA: se agrupa por la altura a la que cae cada ficha, asi
       que cada fila vuelve a empezar por la izquierda. Las ya marcadas
       siguen contando para saber en que columna va la siguiente. */
    function marcar(reja) {
      var hijos = reja.children, fila = null, col = 0, i, el, top;
      for (i = 0; i < hijos.length && n < 160; i++) {
        el = hijos[i];
        if (el.nodeType !== 1 || banned(el)) continue;
        top = Math.round(el.getBoundingClientRect().top);
        if (fila === null || Math.abs(top - fila) > 8) { fila = top; col = 0; } else { col++; }
        if (el.hasAttribute('data-cmf-card')) continue;
        if (!movil && col) el.style.setProperty('--cmf-d', Math.min(col, 4) * EASE_D + 'ms');
        el.setAttribute('data-cmf-card', '');
        obs.observe(el);
        pendientes.push(el);
        n++;
      }
    }

    var rejas = document.querySelectorAll('.product-grid, .resource-list, .editorial-product-grid, .cm-grid__items, .product-list__grid');
    for (var g = 0; g < rejas.length; g++) {
      if (banned(rejas[g])) continue;
      marcar(rejas[g]);
      /* La coleccion carga mas productos al llegar abajo: lo que entre
         despues se marca tambien, para que no haya media rejilla con
         entrada y media sin ella. */
      if ('MutationObserver' in window) {
        (function (reja) {
          var tm;
          new MutationObserver(function () {
            clearTimeout(tm);
            tm = setTimeout(function () { marcar(reja); }, 220);
          }).observe(reja, { childList: true });
        }(rejas[g]));
      }
    }

    /* RED DE SEGURIDAD. Dos redes, no una:
       1) a los 5 s, si NI UNA ficha ha salido del estado de partida, es que
          el mecanismo entero ha fallado -> se sueltan TODAS. Nunca se queda
          un escaparate en blanco por una animacion.
       2) y en cualquier caso, lo que a los 5 s este a la vista y siga
          recortado, se suelta. */
    if (n) {
      setTimeout(function () {
        var movidas = 0, i;
        for (i = 0; i < pendientes.length; i++) {
          if (pendientes[i].getAttribute('data-cmf-card') !== '') movidas++;
        }
        for (i = 0; i < pendientes.length; i++) {
          if (pendientes[i].getAttribute('data-cmf-card') !== '') continue;
          var r = pendientes[i].getBoundingClientRect();
          if (!movidas || (r.top < window.innerHeight && r.bottom > 0)) {
            pendientes[i].setAttribute('data-cmf-card', 'done');
          }
        }
      }, 5000);
    }
    return n;
  }

  /* ========================================================================
     7 · PARALAJE DE LA FOTO DENTRO DE SU MASCARA
     Un unico rAF para todas las fotos, y solo mientras alguna esta a la
     vista. Dentro del bucle NO se lee ni un rectangulo: la posicion de cada
     foto en el documento esta cacheada y se recalcula al cambiar el tamano
     de la ventana. El `transform` se escribe en el propio `img`.
     Solo entran fotos `object-fit: cover`: las fichas de producto de
     coleccion van en `contain` (la prenda flota sobre su placa gris) y ahi
     un paralaje despegaria la prenda de la placa.
     ===================================================================== */
  function paralaje() {
    if (!has('cmf-par') || REDUCED.matches) return 0;
    var VIAJE = 18;   /* px arriba y abajo */
    var ZOOM = 1.08;  /* holgura para que el viaje nunca ensene un borde */
    var items = [];

    /* Se buscan por COMO SON, no por como se llaman: cualquier foto
       recortada a sangre (`object-fit: cover`) dentro de una caja que la
       recorta, y lo bastante grande para que 18 px se noten.
       FUERA a proposito:
       - `.card-gallery` y `.product-media-container`: las fichas de producto
         van en `contain` (la prenda flota sobre su placa) y la galeria de la
         ficha es la foto que el cliente ha venido a mirar;
       - los videos, que ya se mueven solos. */
    var FUERA = '.card-gallery,.product-media-container,.jdgm-widget,.influ,.collage-drag-slider';
    var cands = document.querySelectorAll('main img');
    for (var i = 0; i < cands.length && items.length < 14; i++) {
      var img = cands[i];
      if (banned(img)) continue;
      try { if (img.closest(FUERA)) continue; } catch (e) { continue; }
      if (getComputedStyle(img).objectFit !== 'cover') continue;
      if (img.clientWidth < 240 || img.clientHeight < 180) continue;
      var caja = img.parentElement, salto = 0;
      while (caja && caja !== document.body && salto++ < 5 &&
             getComputedStyle(caja).overflow === 'visible') caja = caja.parentElement;
      if (!caja || caja === document.body) continue;
      img.setAttribute('data-cmf-par', '');
      items.push({ img: img, caja: caja, top: 0, h: 0, y: 999 });
    }
    if (!items.length) return 0;

    function medir() {
      var sy = window.pageYOffset;
      for (var i = 0; i < items.length; i++) {
        var r = items[i].caja.getBoundingClientRect();
        items[i].top = r.top + sy;
        items[i].h = r.height;
      }
    }

    var vivos = 0, corriendo = false;
    var obs = new IntersectionObserver(function (es) {
      for (var i = 0; i < es.length; i++) {
        var it = null;
        for (var j = 0; j < items.length; j++) if (items[j].caja === es[i].target) it = items[j];
        if (!it) continue;
        if (es[i].isIntersecting) {
          if (!it.vivo) { it.vivo = true; vivos++; }
        } else if (it.vivo) {
          it.vivo = false; vivos--;
          it.img.setAttribute('data-cmf-par', 'rest');
        }
      }
      if (vivos && !corriendo) { corriendo = true; requestAnimationFrame(paso); }
    }, { rootMargin: '10% 0px 10% 0px' });
    for (var k = 0; k < items.length; k++) obs.observe(items[k].caja);

    function paso() {
      if (!vivos) { corriendo = false; return; }
      var sy = window.pageYOffset, vh = window.innerHeight, i;
      /* leer (nada del DOM: todo cacheado) */
      var ys = [];
      for (i = 0; i < items.length; i++) {
        if (!items[i].vivo) { ys.push(null); continue; }
        var centro = items[i].top + items[i].h / 2 - sy;
        var p = (centro - vh / 2) / vh;
        if (p > 1) p = 1; else if (p < -1) p = -1;
        ys.push(Math.round(-p * VIAJE * 10) / 10);
      }
      /* escribir */
      for (i = 0; i < items.length; i++) {
        if (ys[i] === null || ys[i] === items[i].y) continue;
        items[i].y = ys[i];
        items[i].img.setAttribute('data-cmf-par', '');
        items[i].img.style.transform = 'translate3d(0,' + ys[i] + 'px,0) scale(' + ZOOM + ')';
      }
      requestAnimationFrame(paso);
    }

    medir();
    var tm;
    window.addEventListener('resize', function () { clearTimeout(tm); tm = setTimeout(medir, 220); }, { passive: true });
    window.addEventListener('load', medir);
    return items.length;
  }

  /* ========================================================================
     8 · RESPUESTA AL ANADIR AL CARRITO
     Ni el formulario ni el boton del tema se tocan: se le pone una clase al
     boton de verdad para que se rellene una vez, y se mira la bolita del
     carrito para darle un rebote cuando cambia su cifra.
     ===================================================================== */
  function compra() {
    if (REDUCED.matches) return;

    if (has('cmf-buy')) {
      document.addEventListener('click', function (e) {
        var b = e.target && e.target.closest && e.target.closest('.add-to-cart-button');
        if (!b || b.disabled || banned(b)) return;
        b.style.setProperty('--cmf-fill', 'none');
        void b.offsetWidth;                        /* reinicia la animacion */
        b.style.setProperty('--cmf-fill', 'cmfFill 560ms var(--cmf-ease) forwards');
        b.addEventListener('animationend', function (ev) {
          if (ev.animationName === 'cmfFill') b.style.removeProperty('--cmf-fill');
        }, { once: true });
      }, true);
    }

    if (has('cmf-pop') && 'MutationObserver' in window) {
      var bub = document.querySelector('.cart-bubble');
      if (!bub) return;
      var esperando = false;
      new MutationObserver(function () {
        if (esperando) return;
        esperando = true;
        setTimeout(function () {
          esperando = false;
          bub.classList.remove('cmf-bounce');
          void bub.offsetWidth;
          bub.classList.add('cmf-bounce');
          bub.addEventListener('animationend', function () { bub.classList.remove('cmf-bounce'); }, { once: true });
        }, 60);
      }).observe(bub, { subtree: true, childList: true, characterData: true });
    }
  }

  /* ========================================================================
     9 · CURSOR «VER» sobre las fotos (solo PC con raton)
     Se crea al primer hover y se quita del DOM al dejar de hacer falta:
     lleva `mix-blend-mode`, que abre una capa de composicion, y no tiene
     sentido tenerla abierta mientras no se ve.
     ===================================================================== */
  function cursor() {
    if (!has('cmf-cur') || !FINE.matches || REDUCED.matches) return;
    var SEL = '.card-gallery, .product-media-container, .cm-half__media, .cm-campaign__media, .cm-lookbook__media';
    var el = null, x = -200, y = -200, dentro = false, corriendo = false, quitar;

    function crear() {
      if (el) return;
      el = document.createElement('div');
      el.className = 'cmf-cursor';
      el.setAttribute('aria-hidden', 'true');
      el.appendChild(document.createTextNode('VER'));
      document.body.appendChild(el);
    }
    function paso() {
      if (!el) { corriendo = false; return; }
      el.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0)';
      if (!dentro) { corriendo = false; return; }
      requestAnimationFrame(paso);
    }
    document.addEventListener('pointerover', function (e) {
      if (e.pointerType !== 'mouse') return;
      var z = e.target && e.target.closest && e.target.closest(SEL);
      if (!z || banned(z)) return;
      clearTimeout(quitar);
      crear();
      x = e.clientX; y = e.clientY;
      el.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0)';
      dentro = true;
      el.classList.add('is-on');
      if (!corriendo) { corriendo = true; requestAnimationFrame(paso); }
    }, { passive: true });
    document.addEventListener('pointermove', function (e) {
      if (!dentro) return;
      x = e.clientX; y = e.clientY;
    }, { passive: true });
    document.addEventListener('pointerout', function (e) {
      if (!dentro) return;
      var z = e.target && e.target.closest && e.target.closest(SEL);
      if (!z) return;
      if (e.relatedTarget && e.relatedTarget.closest && e.relatedTarget.closest(SEL)) return;
      dentro = false;
      if (el) el.classList.remove('is-on');
      quitar = setTimeout(function () {
        if (!dentro && el) { el.remove(); el = null; }
      }, 700);
    }, { passive: true });
  }

  /* ===================================================================== */
  function arrancar() {
    var r = {};
    try { r.titulares = titulares(); } catch (e) { r.e1 = String(e); }
    try { r.rotulos = rotulos(); } catch (e) { r.e2 = String(e); }
    try { r.rodillo = rodillo(); } catch (e) { r.e3 = String(e); }
    try { r.lineas = lineas(); } catch (e) { r.e4 = String(e); }
    try { r.rejillas = rejillas(); } catch (e) { r.e5 = String(e); }
    try { r.paralaje = paralaje(); } catch (e) { r.e6 = String(e); }
    try { compra(); } catch (e) { r.e7 = String(e); }
    try { cursor(); } catch (e) { r.e8 = String(e); }
    window.CMF = r;   /* para poder verificarlo desde el navegador */
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar, { once: true });
  } else {
    arrancar();
  }

  /* El editor de temas vuelve a pintar secciones sueltas: al hacerlo, lo que
     haya nuevo se marca otra vez. Nunca en la tienda, solo en el editor. */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () { setTimeout(arrancar, 60); });
  }
}());
